jQuery(document).ready(function ($) {
    let cartSpinner = $('.woocommerce-cart-form__spinner');

    $( document.body ).on('updated_cart_totals', function(){
        cartSpinner.removeClass('loaded');
    });

    $('form.woocommerce-cart-form .cart-table .cart-table__body .product .remove a').on('click', function(){
        cartSpinner.addClass('loaded');

        $(this).parent().parent().addClass('removing');
    });


    $('.cart_totals .wc-proceed-to-checkout .checkout-button').on('click',function(){
        $('.spinner-main').addClass('loaded');
    });


    $('.totals-coupon .coupon button.vet-button').on('click',function(){
        cartSpinner.addClass('loaded');
    });


    $( document.body ).on('applied_coupon', function(){
        cartSpinner.removeClass('loaded');
    });

});